import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import PatientPortalShell from '@/modules/referral/components/PatientPortalShell';
import { patientPortalApi } from '../api/patientPortal.api';
import PatientHomeHero from '../components/PatientHomeHero';
import PatientQuickActions from '../components/PatientQuickActions';
import PatientUpcomingList from '../components/PatientUpcomingList';
import PatientReferralTeaser from '../components/PatientReferralTeaser';
import PatientFamilyPreview from '../components/PatientFamilyPreview';
import PatientCareTips from '../components/PatientCareTips';
import { IITH } from '@/pages/landing/iithBrand';

/** Patient landing — campus health hub after login. */
export default function PatientHomePage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    patientPortalApi.home()
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#E8EEF5]">
        <Loader2 className="h-8 w-8 animate-spin text-[#F15A22]" />
      </div>
    );
  }

  const branding = data?.tenant?.branding || {};
  const primary = branding.primary_color || IITH.saffron;
  const name = data?.patient?.name || data?.user?.name || '';
  const isFacultyStaff = Boolean(data?.is_faculty_staff);

  return (
    <PatientPortalShell wide>
      <PatientHomeHero name={name} branding={branding} />
      <PatientQuickActions primary={primary} isFacultyStaff={isFacultyStaff} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:gap-6">
        <PatientUpcomingList items={data?.upcoming_appointments || []} primary={primary} />
        {isFacultyStaff && (
          <PatientReferralTeaser items={data?.recent_referrals || []} primary={primary} />
        )}
      </div>
      {isFacultyStaff && (
        <PatientFamilyPreview
          members={data?.family || []}
          selfId={data?.patient?.id}
          primary={primary}
        />
      )}
      <PatientCareTips branding={branding} />
    </PatientPortalShell>
  );
}
